import angular from 'angular'
import loaderComponent from './loader.component'
import LoaderFactory from './loader.factory';

let loaderModule = angular.module('loader', [])

    .component('loader', loaderComponent)

    .factory('Loader', LoaderFactory)

    .name

export default loaderModule



// WEBPACK FOOTER //
// ./client/app/common/loader/loader.js